import { UserRoles } from '../components/roster/types';

/**
 * Check if role is equal or greater than the required role.
 * @param requiredRole
 * @param userRole
 */
export const checkPermission = (requiredRole: UserRoles, userRole: UserRoles) => {
    switch (requiredRole) {
        case UserRoles.Teacher:
            return userRole === UserRoles.Teacher;
        case UserRoles.Assistant:
            return [UserRoles.Teacher, UserRoles.Assistant].includes(userRole);
        case UserRoles.Student:
            return [UserRoles.Teacher, UserRoles.Assistant, UserRoles.Student, UserRoles.Guest].includes(userRole);
        case UserRoles.Guest:
            return [UserRoles.Teacher, UserRoles.Assistant, UserRoles.Student, UserRoles.Guest].includes(userRole);
        default:
            throw new Error(`Invalid role: ${requiredRole}`);
    }
};
